<template>
  <div class="addressField">
    <div class="label">
      <span class="required">*</span>{{ label }}
    </div>
    <div class="value">
      <input v-model="AddressField" type="text" placeholder="输入您的工作单位" @input="handleInput" />
    </div>
  </div>
</template>

<script>
export default {
  name: "AddressField",
  components: {},
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      AddressField: "",
    };
  },
  async mounted() {},
  methods: {
    handleInput(val) {
      this.AddressField = val.target.value;
      this.$emit("input", val.target.value);
    },
  },
  watch: {
    value(newVal) {
      this.AddressField = newVal;
    },
  },
};
</script>

<style scoped lang="scss">
.addressField {
  display: flex;
  align-items: center;
  padding: 12px 0px;
}
.label {
  font-size: 14px;
  color: #333333;
  width: 80px;
  .required{
    color: #FF0000;
  }
}
.value {
  flex: 1;
  display: flex;
  align-items: center;
  height: 33px;
  border-radius: 17px;
  background: #F8F8F8;
  padding-left: 16px;
  font-size: 14px;
  input {
    border: none;
    outline: none;
    background: transparent;
    &::placeholder {
      color: rgba(51,51,51,0.4);
    }
  }
}
</style>
